// Client-side state of a signed-in company (chat copy, running jobs, hidden guide, rejected
// proposals, agent-check drafts) and the "access revoked" signal.
// When pilot access is removed (any API answer 403 {code: "revoked"}) or the company deletes its
// data, the browser forgets all of it.

const LOCAL_PREFIX = "semafor_";
/** The in-memory demo keeps its "server" data under this prefix; that is not client state. */
const DEMO_PREFIX = "semafor_mock";

/** Removes everything this app stored in the browser for the signed-in company. */
export function clearClientState(): void {
  for (const store of [safeStorage("local"), safeStorage("session")]) {
    if (!store) continue;
    const keys: string[] = [];
    for (let i = 0; i < store.length; i++) {
      const k = store.key(i);
      if (k && k.startsWith(LOCAL_PREFIX) && !k.startsWith(DEMO_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => store.removeItem(k));
  }
}

function safeStorage(kind: "local" | "session"): Storage | null {
  try {
    return kind === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

type Listener = () => void;
const listeners = new Set<Listener>();

/** Called by the API layer when the server answers 403 {code: "revoked"}. */
export function notifyRevoked(): void {
  listeners.forEach((l) => l());
}

export function onRevoked(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
